import { LocationOnOutlined } from '@mui/icons-material';
import { Divider, Grid, Stack } from '@mui/material';

import { CustomAccordion } from '../../../components/CustomAccordion';
import { type Veranstaltung } from '../../../dtos';
import { formatDateRange } from '../../../utils/dateFormat';

type VeranstaltungsOrtProps = {
  readonly veranstaltung: Veranstaltung;
};

export const VeranstaltungsOrtComponent = ({ veranstaltung }: VeranstaltungsOrtProps) => (
  <CustomAccordion open title="Veranstaltungsort" icon={LocationOnOutlined}>
    <span style={{ display: 'block', marginBottom: '6px' }}>
      <b>{veranstaltung.ortBezeichnung}</b>
    </span>
    <Grid container spacing={1} rowSpacing={-5}>
      <Grid size={5}>Ort-ID:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.ortid}</b>
      </Grid>
      <Grid size={5}>Ort-Kürzel:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.ortKuerzel}</b>
      </Grid>
      <Grid size={5}>Produktionsort-ID:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.produktionsortid}</b>
      </Grid>
      <Grid size={5}>Übernachtungshotel-ID:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.veranstaltungsHotelId}</b>
      </Grid>
      <Grid size={12}>
        <Stack>
          {veranstaltung.raumBlockungen.map((raumBlockung) => (
            <div key={`raum-${raumBlockung.id}`}>
              <Divider sx={{ margin: '12px' }} />
              <b>Raum-SAP-ID: {raumBlockung.raumSapId}</b>
              <br />
              {raumBlockung.raum && (
                <>
                  Raum-Name:{' '}
                  <b>
                    {raumBlockung.raum.name} {raumBlockung.raum.kuerzel}
                  </b>
                  <br />
                </>
              )}
              Zeitraum: <b>{formatDateRange(new Date(raumBlockung.starttime), new Date(raumBlockung.endtime))}</b>
              <br />
            </div>
          ))}
        </Stack>
      </Grid>
    </Grid>
  </CustomAccordion>
);
